import { WithSnowplow, createFeatureFlagContext, featureFlagFilters } from '@montugroup/data-collection';
import { BrandThemeProvider, alternaleaf } from '@montugroup/themes';
import { QueryClientProvider } from '@tanstack/react-query';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import type { ReactNode } from 'react';
import { useMemo } from 'react';

import { queryClient } from '@/config/queryClient';
import { snowplowSettings } from '@/constants/constants';

type AppProvidersProps = {
  children: ReactNode;
  flags: Record<string, boolean>;
  hashedUserEmail?: string;
  enableSnowplow: boolean;
};

export const AppProviders = ({ children, flags, hashedUserEmail, enableSnowplow }: AppProvidersProps) => {
  const ldClient = useLDClient();

  const flagContext = useMemo(
    () =>
      createFeatureFlagContext({
        ldClient,
        flags,
        filter: featureFlagFilters.includeOnly([]),
      }),
    [flags, ldClient],
  );

  return WithSnowplow(
    <QueryClientProvider client={queryClient}>
      <BrandThemeProvider theme={alternaleaf}>{children}</BrandThemeProvider>
    </QueryClientProvider>,
    {
      appId: snowplowSettings.appId,
      trackerName: snowplowSettings.trackerName,
      userId: hashedUserEmail,
      pageViewContext: flagContext,
      pluginsOverride: {
        buttonClickTracking: { enabled: true, config: { context: flagContext } },
        linkClickTracking: { enabled: true, config: { trackContent: true, context: flagContext } },
      },
    },
    enableSnowplow,
  );
};
